var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.detailsFile
        ? _c(
            "b-modal",
            {
              ref: "modal-action-" + _vm.action,
              attrs: {
                id: "modal-action-" + _vm.action,
                title: _vm.title + " documento",
                "ok-title": _vm.title,
                "cancel-title": "Cancelar",
                "no-close-on-backdrop": "",
                size: "lg",
                centered: ""
              },
              on: { ok: _vm.commitAction, cancel: _vm.cancelProcess }
            },
            [
              _c("b-overlay", { attrs: { show: _vm.loading } }, [
                !_vm.confirmed
                  ? _c("div", { staticClass: "my-5" }, [
                      _c(
                        "p",
                        { staticClass: "warning-confirmation" },
                        [
                          _vm._v(" Antes de "),
                          _vm.processDocument === "foliar"
                            ? _c("span", [_vm._v(" numerar ")])
                            : _vm._e(),
                          _vm.processDocument === "tramitar"
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.processDocument) + " ")
                              ])
                            : _vm._e(),
                          _vm._v(" este documento por favor "),
                          _c("b", [
                            _vm._v(
                              "asegúrate de que la lista de destinatarios es la correcta"
                            )
                          ]),
                          _vm._v(" y además queremos que sepas que "),
                          _c("b", [
                            _vm._v(
                              "vas a gestionar este documento para la oficina"
                            )
                          ]),
                          _c("b", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.stepId.temporalAutorUsuarioNombre) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _vm._v(
                            " (para revisar los destinatarios, haz click sobre el botón que se ve en la parte inferior izquierda que se ve así "
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "btn-icon rounded-circle shadow-lg mx-3 bg-white",
                              attrs: { variant: "outline-info" }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "UsersIcon" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" ) ")
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-warning", size: "sm" },
                              on: { click: _vm.confirmManagement }
                            },
                            [_vm._v(" Esta bien, confirmo! ")]
                          )
                        ],
                        1
                      ),
                      _vm.noAction
                        ? _c(
                            "div",
                            { staticClass: "text-danger text-center mt-4" },
                            [
                              _c("b", [
                                _vm._v(
                                  " Por favor, confirma e ingresa la información requerida para poder "
                                ),
                                _vm.processDocument === "foliar"
                                  ? _c("span", [_vm._v(" numerar ")])
                                  : _vm._e(),
                                _vm.processDocument === "tramitar"
                                  ? _c("span", [
                                      _vm._v(
                                        " " + _vm._s(_vm.processDocument) + " "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" el documento ")
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm.confirmed
                  ? _c("div", { staticClass: "-mt-2" }, [
                      _vm.process
                        ? _c("div", { staticClass: "mb-2" }, [
                            _vm.noNumeration
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "warning-confirmation my-2 text-center"
                                  },
                                  [
                                    _vm._v(
                                      " Hey! Este documento no esta disponible para numeración "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-around" },
                              [
                                _vm.processDocument === "foliar"
                                  ? _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          plain: "",
                                          name: "some-radios3",
                                          value: "foliar"
                                        },
                                        on: { change: _vm.setManagementType },
                                        model: {
                                          value: _vm.processDocument,
                                          callback: function($$v) {
                                            _vm.processDocument = $$v
                                          },
                                          expression: "processDocument"
                                        }
                                      },
                                      [_vm._v(" Numerar ")]
                                    )
                                  : _vm._e(),
                                _vm.processDocument === "tramitar"
                                  ? _c(
                                      "b-form-radio",
                                      {
                                        attrs: {
                                          plain: "",
                                          name: "some-radios4",
                                          value: "tramitar"
                                        },
                                        on: { change: _vm.setManagementType },
                                        model: {
                                          value: _vm.processDocument,
                                          callback: function($$v) {
                                            _vm.processDocument = $$v
                                          },
                                          expression: "processDocument"
                                        }
                                      },
                                      [_vm._v(" Tramitar ")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "form",
                        {
                          staticClass: "mt-4",
                          attrs: { "data-vv-scope": "sign-document" }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-6 mt-3" },
                              [
                                _c("label", [_vm._v("Fecha")]),
                                _c("b-form-datepicker", {
                                  staticClass: "w-100",
                                  attrs: {
                                    min: _vm.min,
                                    id: "example-datepicker",
                                    "label-help":
                                      "Puede usar las flechas del teclado y espacio"
                                  },
                                  model: {
                                    value: _vm.manageDate,
                                    callback: function($$v) {
                                      _vm.manageDate = $$v
                                    },
                                    expression: "manageDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-6 mt-3" },
                              [
                                _c(
                                  "vs-select",
                                  {
                                    staticClass:
                                      "w-100 con-select autocompletex",
                                    attrs: {
                                      autocomplete: "",
                                      label: "Seleccione tipo de Firma"
                                    },
                                    model: {
                                      value: _vm.signType,
                                      callback: function($$v) {
                                        _vm.signType = $$v
                                      },
                                      expression: "signType"
                                    }
                                  },
                                  _vm._l(
                                    _vm.userSignConfiguration.userSigns,
                                    function(firma) {
                                      return _c("vs-select-item", {
                                        key: firma.id,
                                        attrs: {
                                          value: firma,
                                          text: _vm.providerName(
                                            firma.proveedor
                                          )
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-6 mt-3" },
                              [
                                _vm.signerProviderConfig.otp
                                  ? _c("vs-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      staticClass: "w-100",
                                      attrs: {
                                        type: "number",
                                        label: "Código OTP",
                                        maxlength: "6",
                                        name: "otp",
                                        danger: _vm.errors.has(
                                          "sign-document.otp"
                                        ),
                                        "danger-text": _vm.errors.first(
                                          "sign-document.otp"
                                        )
                                      },
                                      model: {
                                        value: _vm.otpCode,
                                        callback: function($$v) {
                                          _vm.otpCode = $$v
                                        },
                                        expression: "otpCode"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "numerateModal",
          attrs: {
            "title-class": "font-weight-bold text-success",
            centered: "",
            size: "sm",
            "no-close-on-backdrop": "",
            title: "Genial!",
            id: "numerateModal",
            "hide-header-close": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "success" },
                          on: {
                            click: function($event) {
                              ok(_vm.$router.back())
                            }
                          }
                        },
                        [_vm._v(" Ok ")]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm.processDocument === "foliar"
            ? _c("h5", [
                _vm._v(" Se ha numerado el documento con el "),
                _c("b", [_vm._v("número #" + _vm._s(_vm.folio))])
              ])
            : _c("h5", [_vm._v("Se ha tramitado el documento exitosamente")])
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "modal-action-office-agile",
          attrs: {
            id: "modal-action-office-agile",
            title: _vm.title + " documento",
            "ok-title": _vm.title,
            "no-close-on-backdrop": "",
            "cancel-title": "Cancelar",
            size: "sm"
          },
          on: { ok: _vm.commitActionAgile, cancel: _vm.cancelProcess }
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loading } }, [
            _c(
              "form",
              {
                staticClass: "d-flex justify-content-center",
                attrs: {
                  autocomplete: "off",
                  "data-vv-scope": "sign-document-agile"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("p", [
                        _vm._v(
                          " Se ha enviado un código de seguridad a tu dirección de correo electrónico. Por favor, revisa tu bandeja de entrada. El correo contendrá un código de seguridad único que deberás ingresar para completar el proceso de registro. "
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          " Si no encuentras el correo electrónico en tu bandeja de entrada, te recomendamos verificar la carpeta de correo no deseado (spam). "
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          " Recuerda que el código de seguridad es personal y confidencial. No lo compartas con nadie y asegúrate de ingresarlo correctamente. "
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.otpCode,
                              expression: "otpCode"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            placeholder:
                              "Ingresar código que se envió a su correo"
                          },
                          domProps: { value: _vm.otpCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.otpCode = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }